/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { features, language } from "config";
import { FirebaseContext } from "common";
import AlertDialog from "../../components/AlertDialog";
import MaterialReactTableManageAdmins from "components/MaterialReactTableManageAdmins";
import { Box, Button, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from 'xlsx';

export default function ManageLandlords(props) {
  const { api } = useContext(FirebaseContext);
  const {
    createLandlord,
    updateLandlord,
    editUser,
    deleteUser,
    checkUserExists,
    emailSignUp,
    adminEmailSignUp,
    clearLoginError,
  } = api;

  const branchManagementReducer = useSelector((state) => state.branchData);
  const auth = useSelector((state) => state.auth);
  const landlordManagementReducer = useSelector((state) => state.landlorddata);
  const dispatch = useDispatch();


  const [data, setData] = useState([]);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });





  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  const columns = [
    {
      id: "id",
      header: "Hidden id",
      columns: [
        {
          accessorKey: "id",
          header: "User id",
          enableEditing: false,
          Edit: () => null, //don't render anything in the editing modal for this column
          //or Edit: ({ cell, renderedCellValue }) => <>{renderedCellValue}</>, //render the normal cell value instead of a text field
          enableHiding: true,
        },
      ],
    },
    {
      accessorKey: "ownerName",
      header: "Owner Name",
    },
    {
      accessorKey: "office",
      header: "Office",
      editable: 'never'
    },
    {
      accessorKey: "companyRegNumber",
      header: "Company Reg Number",
    },
    {
      accessorKey: "companyEmail",
      header: "Company Email",
      Cell: ({ cell }) =>
        features.AllowCriticalEditsAdmin ? cell.getValue() : "Hidden for Demo",
    },
    {
      accessorKey: "companyContactNumber",
      header: language.mobile,
      Cell: ({ cell }) =>
        features.AllowCriticalEditsAdmin ? cell.getValue() : "Hidden for Demo",
    },
    {
      accessorKey: "companyName",
      header: "Company Name",
    },
  ];

  const handleAddRow = async (newRow) => {


    newRow["office"] = auth.info.profile.adminHomeOffice; //branchLookup[newRow.BranchName];

    dispatch(createLandlord(newRow))


  };

  const handleUpdateRow = (updatedRow) => {
    updatedRow["office"] = auth.info.profile.adminHomeOffice; //branchLookup[newRow.BranchName];

    dispatch(updateLandlord(updatedRow));
  };

  const handleDeleteRow = (rowToDelete) => {
    if (features.AllowCriticalEditsAdmin) {
      dispatch(deleteUser(rowToDelete.id));
    } else {
      alert(language.demo_mode);
    }
  };

  // Function to export landlords to Excel
  const exportToExcel = () => {
    const excelData = landlordManagementReducer.landlords.map(landlord => ({
      "Owner Name": landlord.ownerName,
      "Company Name": landlord.companyName,
      "Company Reg Number": landlord.companyRegNumber,
      "Company Email": landlord.companyEmail,
      "Company Contact Number": landlord.companyContactNumber,
      "Office": landlord.office,
      "Create Date": landlord.createDate ? new Date(landlord.createDate).toLocaleDateString() : "",
    }));

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Landlords");

    // Generate Excel file
    XLSX.writeFile(workbook, `landlords_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  return landlordManagementReducer.loading ? (
    <CircularLoading />
  ) : (
    <Box>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Manage Landlords</Typography>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={exportToExcel}
          sx={{ textTransform: 'none' }}
        >
          Download Excel
        </Button>
      </Box>
      <MaterialReactTableManageAdmins
        data={landlordManagementReducer.landlords}
        columns={columns}
        userInitialState={{
          columnVisibility: { id: false }, // This hides the "id" column initially
        }}
        onRowAdd={handleAddRow}
        onRowUpdate={handleUpdateRow}
        onRowDelete={handleDeleteRow}
      />
    </Box>
  );
}
